import store from 'app/store';

export default (Collection, id, items) => {
  store.dispatch(Collection.remove(id, items));
};
